module.exports = {
          srcSet: __webpack_public_path__ + "1367e2521e60710d8d8c972e7949e765-29.png"+" 29w",
          images:[ {path: __webpack_public_path__ + "1367e2521e60710d8d8c972e7949e765-29.png",width: 29,height: 29}],
          src: __webpack_public_path__ + "1367e2521e60710d8d8c972e7949e765-29.png",
          toString:function(){return __webpack_public_path__ + "1367e2521e60710d8d8c972e7949e765-29.png"},
          
          width: 29,
          height: 29
        }